type ScrollToPageTopOptions = {
  defer?: boolean;
};

function performScrollToTop() {
  if (typeof window === "undefined") return;

  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const mainMenu = document.getElementById("mainMenu");
  if (mainMenu) mainMenu.scrollTop = 0;

  const content = document.getElementById("content");
  if (content) content.scrollTop = 0;
}

export function scrollToPageTop(options: ScrollToPageTopOptions = {}) {
  performScrollToTop();

  if (!options.defer || typeof window === "undefined") return;

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      performScrollToTop();
    });
  });
}
